import { useEffect } from "react";
import {
  MAX_HEIGHT_MOBILE_LANDSCAPE,
  MAX_WIDTH_MOBILE,
  MAX_WIDTH_MOBILE_LANDSCAPE,
  MAX_WIDTH_TABLET,
} from "../constants/dimension";
import { useAppDispatch } from "../components/hooks";
import { setScreenSize } from "../store/slices/appState";
import { isPwaInstalled } from "../models/system";

export function useResizeScreen() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handler = () => {
      // for pwa
      if (isPwaInstalled() && window.innerWidth <= MAX_WIDTH_TABLET) {
        window.scrollTo(0, 0);
      }

      if (window.innerWidth > MAX_WIDTH_TABLET)
        dispatch(setScreenSize("desktop"));
      else if (window.innerWidth <= MAX_WIDTH_MOBILE)
        dispatch(setScreenSize("mobile"));
      else if (
        window.innerHeight <= MAX_HEIGHT_MOBILE_LANDSCAPE &&
        window.innerWidth <= MAX_WIDTH_MOBILE_LANDSCAPE
      )
        dispatch(setScreenSize("mobile-landscape"));
      else if (
        window.innerWidth > window.innerHeight &&
        window.innerWidth > MAX_WIDTH_MOBILE_LANDSCAPE
      )
        dispatch(setScreenSize("tablet-landscape"));
      else dispatch(setScreenSize("tablet"));
    };

    const IOS_SETTLE_DELAYS_MS = [100, 300, 500];
    const settleTimers: ReturnType<typeof setTimeout>[] = [];

    const scheduleHandler = () => {
      handler();
      settleTimers.forEach(clearTimeout);
      IOS_SETTLE_DELAYS_MS.forEach((delay) =>
        settleTimers.push(setTimeout(handler, delay)),
      );
    };

    handler();
    window.addEventListener("resize", scheduleHandler);
    window.addEventListener("orientationchange", scheduleHandler);
    return () => {
      settleTimers.forEach(clearTimeout);
      window.removeEventListener("resize", scheduleHandler);
      window.removeEventListener("orientationchange", scheduleHandler);
    };
  }, [dispatch]);

  return null;
}
